import React, { useState, useRef } from 'react';
import '../App.css'
import axios from 'axios';
import './feedbackButton.css'
import { ChakraProvider } from '@chakra-ui/react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Button,
    Textarea
} from '@chakra-ui/react'
import { useToast } from '@chakra-ui/react'
import StarRating from "../starRating/starRating";


const FeedbackLink = (props) => {
    const OverlayTwo = () => (
        <ModalOverlay
            bg='blackAlpha.300'
            backdropFilter='blur(10px) hue-rotate(90deg)'
        />
    )
    const SERVER_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/';
    const FEEDBACK_SERVER_URL = SERVER_URL + 'submit-feedback';
    const { isOpen, onOpen, onClose } = useDisclosure()
    const [overlay, setOverlay] = React.useState(<OverlayTwo />)

    const [rating, setRating] = useState(5);
    const [feedback, setFeedback] = useState('');
    const [error, setError] = useState(null); // Handle error state
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submittingRef = useRef(false);

    const toast = useToast({ position: 'top-right' });

    const handleChange = (event) => {
        setFeedback(event.target.value);
    };

    const handleSubmit = async () => {
        // Handle the feedback submission logic
        // Ignore re-entry while a submission is in flight: the ref flips
        // synchronously, so a double click can't post the rating twice.
        if (!rating || submittingRef.current) {
            return;
        }
        submittingRef.current = true;
        setIsSubmitting(true);
        const feedbackPromise = new Promise(async (resolve, reject) => {
            try {
                let feedback_body = {
                    UserEmail: sessionStorage.getItem('userinfo'),
                    Rating: rating,
                    Feedback: feedback,
                }
                let response = await axios.post(FEEDBACK_SERVER_URL, feedback_body);

                if (!response.data.valid) {
                    reject('Failed to submit feedback');
                } else {
                    resolve('Feedback submitted successfully');
                }
            } catch (error) {
                reject('Failed to submit feedback'); // Set the error state if the API call fails
            }
        });

        toast.promise(feedbackPromise, {
            loading: {
                title: props.translate('Submitting feedback'), description: props.translate('Please wait') + '...', duration: 1000, isClosable: true
            },
            success: { title: props.translate('Feedback submitted'), description: props.translate('Thank you for your feedback!'), duration: 1000, isClosable: true, },
            error: { title: props.translate('Submission failed'), description: props.translate('Something went wrong. Please try again.'), duration: 1000, isClosable: true, },
        });

        try {
            await feedbackPromise;
            setFeedback(''); // Clear feedback input
            setRating(5); // Reset rating
            onClose(); // Close modal
        } catch (error) {
            setError(error); // Set error state if submission fails
        } finally {
            submittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    const handleClose = () => {
        if (submittingRef.current) {
            return;
        }
        onClose();
    };

    // const openFeedbackForm = () => {
    //     window.open('https://forms.office.com/e/BS2CZePPQv', '_blank');
    // };

    return (
        <>
            <button className="start-new-btn" style={{ fontSize: props.langOpt === 'Japanese' ? '13px' : '12px' }} onClick={() => {
                setOverlay(<OverlayTwo />)
                onOpen()
            }}>
                <img src="./feedback.svg" alt="feedbackIcon"></img>
                {props.translate("Submit Feedback")}
            </button>
            <ChakraProvider resetCSS={false}>
                <Modal isCentered isOpen={isOpen} onClose={handleClose}>
                    {overlay}
                    <ModalContent>
                        <ModalCloseButton isDisabled={isSubmitting} />
                        <ModalBody>
                            <h2 className="feedback-title">{props.translate("Help us shape a better experience by sharing your feedback!")}</h2>
                            <StarRating rating={rating} setRating={setRating} />
                            <Textarea placeholder={props.translate("Enter your feedback")} onChange={handleChange}></Textarea>
                        </ModalBody>
                        <ModalFooter>
                            <Button onClick={handleClose} mr={3} variant="outline" isDisabled={isSubmitting}>{props.translate('Close')}</Button>
                            <Button bg="#e60000" color="white" _hover={{ bg: '#b80000' }} _active={{ bg: '#990000' }} isLoading={isSubmitting} isDisabled={isSubmitting} onClick={() => handleSubmit()}>{props.translate('Submit')}</Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </ChakraProvider>
        </>
    );
};

export default FeedbackLink;